module.exports = __webpack_public_path__ + "img/893-4b339f.png";